import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCurrencyDollar = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 17 17",
	xmlSpace: "preserve",
	...props,
	children: /* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("circle", {
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			cx: 8.5,
			cy: 8.5,
			r: 7.5
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M6.6,10.6c0.4,0.5,1,0.8,1.7,0.8c1,0,1.9-0.6,1.9-1.4S9.3,8.6,8.3,8.6S6.4,7.9,6.4,7.2 c0.1-0.9,1-1.5,1.9-1.4C9,5.7,9.6,6,10,6.5"
		}),
		/* @__PURE__ */ _jsx("line", {
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			x1: 8.3,
			y1: 11.4,
			x2: 8.3,
			y2: 12.8
		}),
		/* @__PURE__ */ _jsx("line", {
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			x1: 8.3,
			y1: 4.3,
			x2: 8.3,
			y2: 5.6
		})
	] })
});
export { SvgCurrencyDollar as ReactComponent };
